<style lang="scss" src='./SensorChart.scss' scoped></style>
<template src="./SensorChart.html"></template>

<script>
import AlertGraph from "@/components/alertGraph/AlertGraph";
import { GetAlertBySensor } from "@/api/api";

export default {
  name: "SensorChart",
  components: {
    AlertGraph,
  },
  props: {
    sensor: {
      required: true,
    },
  },
  data() {
    return {
    };
  },

  computed: {
  },

  watch: {},

  methods: {

  },

  beforeCreate() {},

  created() {},

  beforeMount() {
  },

  mounted() {
  },

  beforeDestroy() {},
};
</script>
